import React, { useState } from "react";
import { View, StyleSheet, Platform } from "react-native";

import TimePickerManualEntry from "./timepicker/TimePickerManualEntry";
import { TimepickerCalendarTheme } from "../../defaultCalendarTheme";
import { Calendar } from "./calendar";
import Utils from "../../../helpers/utils";
import ManaButton from "./ManaButton";
import AppTheme from "../AppTheme";

const DATE_FORMAT = "YYYY-MM-DD HH:mm";

export default function CalendarTimePicker(props) {
  const { controller, confirm = () => {} } = props;

  const now = Utils.nowUserTz(controller);
  const { week_start } = controller.state?.settings || {};
  const weekStart = week_start == "Sunday" ? 7 : 1;

  const [today] = useState(now.format("YYYY-MM-DD"));
  const [selectedDate, setSelectedDate] = useState(today);
  const [selectedTime, setSelectedTime] = useState(now.format(DATE_FORMAT));

  const startTime = now.format("h:mm a");

  const confirmDate = () => {
    if (!selectedDate || !selectedTime) return;

    const time = selectedTime.split(" ")[1];
    confirm({ name: "Custom", date: `${selectedDate} ${time}` });
  };

  return (
    <View style={{ width: "100%" }}>
      <Calendar
        theme={TimepickerCalendarTheme}
        markedDates={{
          [today]: {
            marked: true,
            dotColor: "#925BE8",
            color: "#000",
          },
          [selectedDate]: {
            selected: true,
            backgroundColor: AppTheme.DEFAULT_COLOR,
            color: "#FFF",
          },
        }}
        current={today}
        monthFormat={"MMMM yyyy"}
        onDayPress={(day) => setSelectedDate(day.dateString)}
        firstDay={weekStart}
      />

      <TimePickerManualEntry
        startTime={startTime}
        timeslotDate={selectedDate}
        label="At"
        style={{ minHeight: 80 }}
        onTimeChanged={(time) => setSelectedTime(time)}
      />

      <View style={styles.buttons}>
        <ManaButton
          onPress={confirmDate}
          style={styles.button}
          styleText={styles.buttonText}
          text={"Back"}
        />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  buttons: {
    width: "100%",
    paddingHorizontal: 8,
    justifyContent: "center",
  },
  button: {
    width: "100%",
    height: 32,
  },
  buttonText: {
    fontFamily: Platform.select({
      default: "Montserrat",
      android: "Montserrat-SemiBold",
    }),
    fontWeight: "500",
    fontSize: 12,
    lineHeight: 15,
    letterSpacing: 0.175,
    color: AppTheme.DEFAULT_COLOR,
  },
});
